@if(loader){
<app-loader></app-loader>
}

<p-card header="">
    <div class="flex justify-content-between align-items-center flex-wrap w-100 position-relative">
        <div class="flex align-items-center">

            <p-button label="New" icon="pi pi-plus-circle" class="p-button-outlined ml-2" size="small"
                (onClick)="showDialog()" pTooltip="Add Report">
            </p-button>

            <div class="ml-2 w-64">
                <p-dropdown [options]="GroupNameList" placeholder="Report Category" [(ngModel)]="selectedGroupName"
                    optionLabel="label" optionValue="value" (onChange)="onGroupNameChange($event)"
                    pTooltip="Select Report Category" tooltipPosition="right" tooltipEvent="hover" [showDelay]="0"
                    [hideDelay]="0" appendTo="body">
                </p-dropdown>
            </div>

            <div class="flex align-items-center ml-3">
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" [(ngModel)]="searchKey" [placeholder]="placeholder"
                        class=" p-inputtext-sm" (keyup.enter)="SearchReport()" autocomplete="one-time-code"
                        style="height: 35px; font-size: 0.875rem; padding-left: 2rem;" />
                </span>
                <p-button icon="pi pi-search" (onClick)="SearchReport()" [ngStyle]="{ height: '35px' }" [raised]="true"
                    class="ml-2" [size]="'small'" severity="info"></p-button>
            </div>

        </div>

        <h2 class="page-title-center">Report Center</h2>

        <div class="flex">
            <div class="flex align-items-center">
                <p-button icon="pi pi-refresh" size="small" (onClick)="refreshData()" [rounded]="true"
                    severity="info"></p-button>
            </div>&nbsp;
        </div>

    </div>

    <p-table #dt1 [value]="reportList" [scrollable]="false" scrollHeight="450px" styleClass="p-datatable-sm"
        responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm " [paginator]="true" [rows]="10"
        [rowsPerPageOptions]="[10,15,20]" [rowHover]="true" [(selection)]="selectedReport"
        [globalFilterFields]="['reportId', 'name', 'description']">
        <ng-template pTemplate="header">
            <tr>
                <!-- <th><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th> -->
                <th>Report Category</th>
                <th>Report Number</th>
                <th>Name</th>
                <th>Description</th>
                <th>View</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-report>
            <tr>
                <!-- <td><p-tableCheckbox [value]="report"></p-tableCheckbox></td> -->
                <td>{{ report.groupName }}</td>
                <td>{{report.reportId}}</td>
                <td class="text-blue-500" style="cursor: pointer;" (click)="openReport(report)">
                    {{report.name}}</td>
                <td>{{report.description}}</td>
                <td class="text-blue-500 underline" style="cursor: pointer;" (click)="openReport(report)"><span
                        class="pi pi-eye"></span></td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="8">No Records found.</td>
            </tr>
        </ng-template>
    </p-table>
</p-card>


@if(visible){
<p-dialog [header]="title" [modal]="true" [(visible)]="visible" [style]="{width: '100%'}" [draggable]="false"
    [resizable]="false">

    <stimulsoft-viewer-angular [requestUrl]="path" [action]="'InitViewer'" [width]="'100%'" [height]="'800px'"
        [properties]="properties"></stimulsoft-viewer-angular>

</p-dialog>
}


<p-dialog header="Add Report" [modal]="true" [(visible)]="addReport" [style]="{width: '60vw'}" [draggable]="false"
    [resizable]="false">
    <form [formGroup]="createReport">

        <div class="flex align-items-start mt-3">
            <div>
                @if (!isEdit) {
                <p-button label="Save" (onClick)="create()" icon="pi pi-save" class="p-button-outlined"
                    size="small"></p-button>
                }
                @else {
                <p-button label="Update" severity="info" (click)="update()" icon="pi pi-arrow-circle-up"
                    size="small"></p-button>
                }
            </div>
        </div>

        <div class="grid mt-3">

            <div class="col">
                <div class="field text-left">
                    <label>Name</label>
                    <input pInputText formControlName="Name"
                        [ngClass]="{'ng-invalid ng-dirty': warn && createReport.controls.Name.errors}"
                        class="w-full p-inputtext-sm" />
                </div>
            </div>

            <div class="col">
                <div class="field text-left">
                    <label>Description</label>
                    <input pInputText formControlName="Description"
                        [ngClass]="{'ng-invalid ng-dirty': warn && createReport.controls.Description.errors}"
                        class="w-full p-inputtext-sm" />
                </div>
            </div>

            <div class="col">
                <div class="field text-left">
                    <label>Path</label>
                    <input pInputText formControlName="Path" type="text"
                        [ngClass]="{'ng-invalid ng-dirty': warn && createReport.controls.Path.errors}"
                        class="w-full p-inputtext-sm" />
                </div>
            </div>


        </div>
    </form>
</p-dialog>



<p-toast></p-toast>